import adminTicketListComponent from './admin-ticket-list.component';

const adminTicketListModule = angular.module('adminTicketList', [
])
  .component('adminTicketList', adminTicketListComponent)
  .name;

export default adminTicketListModule;
